module.exports = __webpack_public_path__ + "img/button.e47b5c52.png";